import ServiceBase from './ServiceBase';

export default class ProjectUpdatesService extends ServiceBase {

    searchProjectUpdates(projectID, filters, lowestFetchedSequenceNumber) {
        const params = {
            projectID,
            lowestFetchedSequenceNumber,
            ...filters,
        };

        return this.request('post', 'projectUpdates/searchProjectUpdates', params);
    }

    searchUserProjectUpdateFeed(filters = {}, pageSize = null, pageIndex = null) {
        const model = {
            pageSize,
            pageIndex,
            ...filters,
        };

        return this.request('get', 'projectUpdates/searchUserProjectUpdateFeed', model);
    }

    toggleLikeUpdate(projectUpdateID) {
        return this.request('post', 'projectUpdates/toggleLikeUpdate', { projectUpdateID });
    }
}
